// export * from './AdditionalDisclosures'

import loadable from '@loadable/component'

export const AdditionalDisclosures = loadable(
  () => import('./AdditionalDisclosures')
)
export type {
  Abs15ELinkListProps,
  AdditionalDisclosureProps,
  AdditonalDisclosuresRenderLinkProps
} from './AdditionalDisclosures'
